























import store from '@/store'

query = "{ businessTypes {
  recordset { Id Name }
} }"

promise = null
list = null

export default {
  name: 'SourceSelectBusinessTypes'
  props: {
    size: { type: String, default: -> null }
    value: { type: Number, default: -> null }
    disabled: { type: Boolean, default: -> no }
    loading: { type: Boolean, default: -> no }
    reselect: { type: Boolean, default: -> yes }
  }
  data: -> {
    selected: null
    list: null
  }
  mounted: -> (
    t = this

    t.$watch 'selected', -> t.$emit 'input', t.selected
    t.$watch 'value', (-> t.selected = t.value), { immediate: yes }
    t._fetch().then (list) ->
      t.list = list
      if t.reselect is yes and not t.selected? and t.list.length > 0 then t.selected = t.list[0].Id
  )
  methods: {
    _fetch: -> (
      t = this
      if list? then return list
      # for now role is global so we only want get it from server one time
      source =
        if promise? and promise instanceof Promise then promise
        else promise = store.dispatch 'centric2', { query }
      # clear promise instance
      promise = null

      this.$emit 'update:loading', yes
      list = (await source).businessTypes?.recordset ? []
      this.$emit 'update:loading', no
      list
    )

    
  }
}
